var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.22 15.2 4.29 2.27c-.56-.56-1.06-.16-1.62.4s-.96 1.06-.4 1.62L15.2 17.22c.55.56 1.05.15 1.61-.4.56-.57.97-1.07.4-1.62zM4.29 17.22 17.22 4.29c.56-.56.15-1.06-.4-1.62-.57-.56-1.07-.96-1.62-.4L2.27 15.2c-.56.55-.16 1.05.4 1.61s1.06.97 1.62.4z"
})));
export default SvgMenuClose;